// extracted by mini-css-extract-plugin
export default {"row2":"FseTable_row2__qXH+e","cards":"FseTable_cards__SRDCM"};